import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import LabelGOCredentialsStore from '../../../../stores/credentials/shipping/labelgo-credentials-store';

interface IProps {
    credentialsStore: LabelGOCredentialsStore,
    vGroup: IValidationGroup,
}

const LabelGOCredentials: React.FC<IProps> = observer(({
                                                       credentialsStore,
                                                       vGroup,
                                                   }) => {
    return (
        <>
            <FormFieldLine
                required
                label='LabelGO username'
                key='username'
                note='Your LabelGO username'
            >
                <Input
                    value={credentialsStore.username}
                    onChange={credentialsStore.setUsername}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='LabelGO password'
                key='password'
                note='Your LabelGO password'
            >
                <Input
                    value={credentialsStore.password}
                    onChange={credentialsStore.setPassword}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='LabelGO Account Number'
                key='account_number'
                note='Your LabelGO Account Number'
            >
                <Input
                    value={credentialsStore.accountNumber}
                    onChange={credentialsStore.setAccountNumber}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='LabelGO API base URL'
                key='base_api_url'
                note='LabelGO Production API base URL, LabelGO team shared with you, e.g https://returngo.shiphub.io'
            >
                <Input
                    value={credentialsStore.baseApiUrl}
                    onChange={credentialsStore.setBaseApiUrl}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default LabelGOCredentials;
